var Cart, DealEventPipe, VariationsWidget,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

Cart = window.Cart != null ? window.Cart : window.Cart = {};

DealEventPipe = require('../../deal/frontend/event_pipe');

Cart.Helpers = require('../../cart/common/helpers');

VariationsWidget.Controller = (function() {
  function Controller() {
    this.findSelectedCollections = bind(this.findSelectedCollections, this);
    this.findDefaultCollections = bind(this.findDefaultCollections, this);
    this.isSelectionDefault = bind(this.isSelectionDefault, this);
    var ref;
    if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub.user.browser : void 0) === 'IE' && OptimizeSuite.TrackingHub.user.browserVersion === '7.0') {
      this.ie7 = true;
    }
    if (typeof I18n !== "undefined" && I18n !== null) {
      this.i18n = I18n.scoped();
    }
    this.updateSelectElements("", true);
    this.availableOptions = this.getAvailableOptions();
    this.cheapestOption = this.getCheapestAvailableOption(this.availableOptions);
    this.lastImage = "";
    this.clearTraitsOnCarouselSelection = VariationsWidget.clearTraitsOnCarouselSelection;
    this.$selectElements = $('#variation-traits').find('.variation-trait');
    if ((ref = VariationsWidget.preSelectTraits) != null ? ref.length : void 0) {
      this.makeSelectionsViaPreselection();
    } else {
      this.updateSelectionsToDefault();
    }
  }

  Controller.prototype.render = function(latestSelection, updateCarousel) {
    if (updateCarousel == null) {
      updateCarousel = true;
    }
    if (latestSelection.selection != null) {
      this.updateSelections(latestSelection);
      this.updateSelectElements(latestSelection.trait);
      this.availableOptions = this.getAvailableOptions();
      this.cheapestOption = this.getCheapestAvailableOption(this.availableOptions);
      this.updatePricing(this.cheapestOption, this.availableOptions.length);
      if (updateCarousel) {
        this.updateCarousel();
      }
      this.removeErrorMessages();
    }
  };

  Controller.prototype.updateSelectionsToDefault = function() {
    var i, len, ref, results, selectElement;
    ref = this.$selectElements || [];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      selectElement = ref[i];
      results.push($(selectElement).find('option:eq(0)').prop('selected', true));
    }
    return results;
  };

  Controller.prototype.updateSelections = function(latestSelection) {
    var collection, i, len, ref;
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      if (collection.models[0].get('traitName') === latestSelection.trait) {
        collection.setSelected(latestSelection.id);
        break;
      }
    }
  };

  Controller.prototype.updateSelectElements = function(latestSelection, updateAll) {
    var availableValues, collection, conditions, enabledOptions, enabledValues, i, j, k, l, lastSelection, len, len1, len2, len3, len4, m, model, option, ref, ref1, ref2, trait, traitName, unavailableOptions, unavailableValues, value;
    if (updateAll == null) {
      updateAll = false;
    }
    if (VariationsWidget.printOptionPrice) {
      updateAll = true;
    }
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      traitName = collection.models[0].get('traitName');
      if (traitName !== latestSelection || updateAll) {
        conditions = this.getConditions(collection.selected());
        lastSelection = _.keys(conditions).length === VariationsWidget.collections.length - 1;
        enabledOptions = [];
        unavailableOptions = [];
        if (!$.isEmptyObject(conditions)) {
          enabledOptions = _.where(VariationsWidget.options, conditions);
        } else {
          enabledOptions = VariationsWidget.options;
        }
        enabledValues = _.pluck(enabledOptions, traitName);
        unavailableValues = _.uniq(enabledValues);
        availableValues = [];
        for (j = 0, len1 = enabledOptions.length; j < len1; j++) {
          option = enabledOptions[j];
          for (k = 0, len2 = unavailableValues.length; k < len2; k++) {
            value = unavailableValues[k];
            if ((value === option[traitName]) && this.isOptionAvailable(option)) {
              availableValues.push(value);
            }
          }
        }
        unavailableValues = _.difference(unavailableValues, availableValues);
        enabledValues.unshift((this.i18n.t('js.modules.variations.selector')) + " " + traitName);
        ref1 = VariationsWidget.collections;
        for (l = 0, len3 = ref1.length; l < len3; l++) {
          trait = ref1[l];
          if (trait.models[0].get('traitName') === traitName) {
            ref2 = trait.models;
            for (m = 0, len4 = ref2.length; m < len4; m++) {
              model = ref2[m];
              this.setOptionState(model, enabledValues, unavailableValues);
              if (lastSelection && (conditions[traitName] == null)) {
                this.setOptionPrice(model, enabledValues, enabledOptions);
              } else if (conditions[traitName] == null) {
                this.setOptionFromPrice(model, enabledValues, enabledOptions);
              } else {
                model.set('optionPrice', false);
              }
            }
          }
        }
      }
    }
    if (this.ie7) {
      $('option').removeClass("ie7-color");
      return $('option[disabled]').addClass("ie7-color");
    }
  };

  Controller.prototype.setOptionState = function(model, enabledValues, unavailableValues) {
    var forceDisplay, printSoldOut;
    printSoldOut = VariationsWidget.printSoldOut;
    if (model.id === 0 || (_.contains(enabledValues, model.get('traitValue')))) {
      if (model.get('isSoldOut') || model.get('isUnavailable') || ((unavailableValues != null) && (_.contains(unavailableValues, model.get('traitValue'))))) {
        model.set('disabled', true);
      } else {
        model.set('disabled', false);
      }
      model.set('forceDisplay', printSoldOut === true);
    } else {
      model.set('disabled', true);
      forceDisplay = printSoldOut === true && !VariationsWidget.hideUnrelatedOption;
      model.set('forceDisplay', forceDisplay);
    }
  };

  Controller.prototype.setOptionFromPrice = function(model, enabledValues, enabledOptions) {
    var cheapestOption, modelID, name, printOptionPrice, selected, traitOptions, value;
    printOptionPrice = VariationsWidget.printOptionPrice;
    if (!printOptionPrice) {
      return;
    }
    value = model.get('traitValue');
    name = model.get('traitName');
    selected = model.get('selected');
    modelID = model.get('id');
    traitOptions = _.filter(enabledOptions, (function(item) {
      return item[name] === value;
    }));
    if (selected || modelID === 0) {
      return model.set('optionPrice', false);
    }
    if (_.contains(enabledValues, value)) {
      cheapestOption = this.getCheapestAvailableOption(traitOptions);
      if (cheapestOption != null) {
        model.set('optionPrice', I18n.t('js.modules.variations.from_price', {
          minPrice: cheapestOption.newPrice
        }));
      }
    }
  };

  Controller.prototype.setOptionPrice = function(model, enabledValues, enabledOptions) {
    var i, len, modelID, name, option, printOptionPrice, selected, value;
    printOptionPrice = VariationsWidget.printOptionPrice;
    if (!printOptionPrice) {
      return;
    }
    value = model.get('traitValue');
    name = model.get('traitName');
    selected = model.get('selected');
    modelID = model.get('id');
    if (selected || modelID === 0) {
      return model.set('optionPrice', false);
    }
    if (_.contains(enabledValues, value)) {
      for (i = 0, len = enabledOptions.length; i < len; i++) {
        option = enabledOptions[i];
        if (value === option[name]) {
          model.set('optionPrice', option.newPrice);
        }
      }
    }
  };

  Controller.prototype.getConditions = function(selected) {
    var conditions, i, len, ref, tempCollection, tempSelected, tempSelectedTraitValue;
    conditions = {};
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      tempCollection = ref[i];
      tempSelected = tempCollection.selected();
      tempSelectedTraitValue = tempSelected.get('traitValue');
      if (tempSelectedTraitValue !== selected.get('traitValue') && !this.isSelectionDefault(tempSelectedTraitValue)) {
        conditions[tempSelected.get('traitName')] = tempSelectedTraitValue;
      }
    }
    return conditions;
  };

  Controller.prototype.getAvailableOptions = function() {
    var collection, i, len, options, properties, ref, selectedTrait, selectedTraitValue;
    properties = {};
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      selectedTrait = collection.selected();
      selectedTraitValue = selectedTrait.get('traitValue');
      if (!this.isSelectionDefault(selectedTraitValue)) {
        properties[selectedTrait.get('traitName')] = selectedTraitValue;
      }
    }
    if ($.isEmptyObject(properties)) {
      options = VariationsWidget.options;
    } else {
      options = _.where(VariationsWidget.options, properties);
    }
    return options;
  };

  Controller.prototype.getCheapestAvailableOption = function(availableOptions) {
    var currentCheapest, i, len, option;
    currentCheapest = void 0;
    for (i = 0, len = availableOptions.length; i < len; i++) {
      option = availableOptions[i];
      if (this.isOptionAvailable(option) && (currentCheapest === void 0 || (option.amount < currentCheapest.amount))) {
        currentCheapest = option;
      }
    }
    return currentCheapest || availableOptions[0];
  };

  Controller.prototype.overridePriceDataWithSaleInfo = function(priceData, option) {
    var i, len, offer, ref, ref1, ref2, ref3, ref4, sale;
    if (!(((option != null ? option.regularPrice : void 0) != null) || (((ref = VariationsWidget.offerCollections) != null ? ref.offerOptions : void 0) != null))) {
      return;
    }
    sale = {};
    if (option.regularPrice) {
      _.extend(sale, {
        urgencyPricing: {
          regularPrice: option.regularPrice,
          newPrice: option.newPrice,
          pricingMetadata: option.pricingMetadata
        }
      });
    }
    ref2 = ((ref1 = VariationsWidget.offerCollections) != null ? ref1.offerOptions : void 0) || [];
    for (i = 0, len = ref2.length; i < len; i++) {
      offer = ref2[i];
      if (offer.uuid === option.uuid) {
        if (((offer != null ? offer.buyUrl : void 0) != null) && !((ref3 = VariationsWidget.offerCollections) != null ? (ref4 = ref3.offerModal) != null ? ref4.isSoldOut : void 0 : void 0)) {
          priceData.buyUrl = offer.buyUrl;
        }
        _.extend(sale, {
          offer: offer
        });
      }
    }
    if (sale !== {}) {
      return _.extend(priceData, {
        sale: sale
      });
    }
  };

  Controller.prototype.updatePricing = function(cheapestOption, length) {
    var priceData;
    priceData = {
      dealUuid: VariationsWidget.uuid,
      id: cheapestOption.id,
      value: cheapestOption.oldPrice,
      percent: cheapestOption.discount,
      savings: cheapestOption.savePrice,
      price: cheapestOption.newPrice,
      lengthClass: cheapestOption.lengthClass,
      buyUrl: this.buyButtonUrl(cheapestOption),
      uuid: cheapestOption.uuid,
      variationsSelected: length === 1 && !this.areAnySelectionsDefault(VariationsWidget.collections),
      hideOriginalPriceAndDiscount: cheapestOption.hideOriginalPriceAndDiscount,
      soldMessage: cheapestOption.soldMessage
    };
    this.overridePriceDataWithSaleInfo(priceData, cheapestOption);
    DealEventPipe.trigger("priceUpdate", priceData);
    if (payload.goodsWarranty) {
      DealEventPipe.trigger("goodsWarrantyUpdate", priceData);
    }
    if (payload.buyMore) {
      return DealEventPipe.trigger("buyMoreUpdate", priceData, !priceData.variationsSelected);
    }
  };

  Controller.prototype.buyButtonUrl = function(cheapestOption) {
    var ref;
    if ((ref = cheapestOption.externalUrl) != null ? ref.length : void 0) {
      return cheapestOption.externalUrl;
    }
    if ((typeof payload !== "undefined" && payload !== null ? payload.cartStatus : void 0) && !payload.shouldDisableGoodsCart) {
      return Cart.Helpers.generateCartUrl(cheapestOption.uuid, VariationsWidget.uuid);
    } else {
      return cheapestOption.url;
    }
  };

  Controller.prototype.updateCarousel = function() {
    var currentImage, foundMatch, imageUrl, ref, valuesHash;
    if (this.areSelectionsDefault(VariationsWidget.collections)) {
      payload.firedByTraitSelection = true;
      DealCarousel.carouselViews[payload.carousel.dealId].updateGallery(DealCarousel.dealMedia[payload.carousel.dealId].models[0]);
    } else {
      ref = VariationsWidget.mappings;
      for (imageUrl in ref) {
        valuesHash = ref[imageUrl];
        foundMatch = _.every(VariationsWidget.collections, (function(_this) {
          return function(collection) {
            var selectedTrait, selectedTraitValue;
            selectedTrait = collection.selected();
            selectedTraitValue = selectedTrait.get('traitValue');
            if (_this.isSelectionDefault(selectedTraitValue)) {
              return true;
            } else {
              return _.contains(valuesHash[selectedTrait.get('traitName')], selectedTraitValue);
            }
          };
        })(this));
        currentImage = DealCarousel.carouselViews[payload.carousel.dealId].currentFeatured.baseURL;
        if (foundMatch && currentImage !== imageUrl) {
          payload.firedByTraitSelection = true;
          this.changeToMatchingImage(imageUrl);
          break;
        }
      }
    }
  };

  Controller.prototype.changeToMatchingImage = function(imgPath) {
    var image;
    this.lastImage = imgPath;
    image = DealCarousel.dealMedia[payload.carousel.dealId].findWhere({
      thumb: imgPath + "t100x100" + payload.carousel.imageQuality + ".jpg"
    });
    return DealCarousel.carouselViews[payload.carousel.dealId].updateGallery(image);
  };

  Controller.prototype.findMatchingTraits = function(img) {
    var key, ref, selections, value;
    this.lastImage = img;
    selections = [];
    if (VariationsWidget.mappings[img] != null) {
      ref = VariationsWidget.mappings[img];
      for (key in ref) {
        value = ref[key];
        if (value.length === 1) {
          selections.push({
            trait: key,
            selection: value[0]
          });
        }
      }
    }
    return this.makeSelectionsViaCarousel(selections);
  };

  Controller.prototype.makeSelectionsViaCarousel = function(selections) {
    if ((selections != null ? selections.length : void 0) < 1 && !this.clearTraitsOnCarouselSelection) {
      return;
    }
    this.clearSelections();
    return this.makeSelections(selections);
  };

  Controller.prototype.makeSelectionsViaPreselection = function() {
    var collection, i, j, len, len1, option, ref, ref1, selections, trait;
    option = _.findWhere(VariationsWidget.options, {
      uuid: VariationsWidget.dealOptionUuid
    });
    if (!((option != null) && this.isOptionAvailable(option))) {
      return;
    }
    selections = [];
    ref = VariationsWidget.preSelectTraits || [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      ref1 = VariationsWidget.collections || [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        collection = ref1[j];
        if (collection.models[0].get("traitName") === trait) {
          selections.push({
            trait: trait,
            selection: option[trait]
          });
          break;
        }
      }
    }
    return this.makeSelections(selections);
  };

  Controller.prototype.clearSelections = function() {
    var collection, data, i, len, ref, results, selectedTrait, selectedTraitName, selection;
    ref = VariationsWidget.collections || [];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      selectedTrait = collection.selected();
      selectedTraitName = selectedTrait.get('traitName');
      if (!this.isSelectionDefault(selectedTrait.get('traitValue'))) {
        selection = this.i18n.t('js.modules.variations.select', {
          name: selectedTraitName
        });
        data = {
          trait: selectedTraitName,
          selection: selection,
          id: 0
        };
        $("#trait-" + (selectedTrait.get('traitIndex'))).val(selection);
        if ($("#trait-" + (selectedTrait.get('traitIndex'))).val() == null) {
          $("#trait-" + (selectedTrait.get('traitIndex'))).prop('selectedIndex', 0);
        }
        results.push(this.render(data, false));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  Controller.prototype.makeSelections = function(selections) {
    var collection, element, i, j, len, len1, ref, ref1, trait;
    ref = selections || [];
    for (i = 0, len = ref.length; i < len; i++) {
      element = ref[i];
      ref1 = VariationsWidget.collections || [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        collection = ref1[j];
        if (collection.models[0].get('traitName') === element.trait) {
          trait = collection.findWhere({
            traitValue: element.selection
          });
          if (!trait.get('disabled')) {
            element['id'] = trait.get('id');
            $('#trait-' + collection.models[0].get('traitIndex')).val(element.selection);
            this.render(element, false);
            break;
          }
        }
      }
    }
  };

  Controller.prototype.showErrorMessages = function() {
    var defaultCollections, i, index, len, results;
    VariationsWidget.error.show();
    VariationsWidget.error.$el.addClass("icon-circle-alert");
    defaultCollections = this.findDefaultCollections(VariationsWidget.collections);
    results = [];
    for (i = 0, len = defaultCollections.length; i < len; i++) {
      index = defaultCollections[i];
      results.push($('#trait-' + index).addClass('error'));
    }
    return results;
  };

  Controller.prototype.removeErrorMessages = function() {
    var i, index, len, results, selectedCollections;
    if (!this.areAnySelectionsDefault(VariationsWidget.collections)) {
      VariationsWidget.error.hide();
    }
    selectedCollections = this.findSelectedCollections(VariationsWidget.collections);
    results = [];
    for (i = 0, len = selectedCollections.length; i < len; i++) {
      index = selectedCollections[i];
      results.push($('#trait-' + index).removeClass('error'));
    }
    return results;
  };

  Controller.prototype.areSelectionsDefault = function(collections) {
    return _.every(collections, (function(_this) {
      return function(collection) {
        return RegExp("(^" + (_this.i18n.t('js.modules.variations.selector')) + "|" + (_this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'));
      };
    })(this));
  };

  Controller.prototype.areAnySelectionsDefault = function(collections) {
    return _.some(collections, (function(_this) {
      return function(collection) {
        return RegExp("(^" + (_this.i18n.t('js.modules.variations.selector')) + "|" + (_this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'));
      };
    })(this));
  };

  Controller.prototype.isSelectionDefault = function(selection) {
    return RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(selection);
  };

  Controller.prototype.findDefaultCollections = function(collections) {
    var collection, defaultCollections, i, index, len;
    defaultCollections = [];
    for (index = i = 0, len = collections.length; i < len; index = ++i) {
      collection = collections[index];
      if (RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'))) {
        defaultCollections.push(index);
      }
    }
    return defaultCollections;
  };

  Controller.prototype.findSelectedCollections = function(collections) {
    var collection, i, index, len, selectedCollections;
    selectedCollections = [];
    for (index = i = 0, len = collections.length; i < len; index = ++i) {
      collection = collections[index];
      if (!RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'))) {
        selectedCollections.push(index);
      }
    }
    return selectedCollections;
  };

  Controller.prototype.isOptionAvailable = function(option) {
    if (option == null) {
      return false;
    }
    return !(option.isSoldOut || option.isUnavailable);
  };

  return Controller;

})();

module.exports = VariationsWidget.Controller;

//# sourceMappingURL=data:application/json;base64,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
